export const api = {
  /* COMMON APIs */
  _agencyDetails: "api/admin/agency/agency-details",
  _permissionsAuth: "api/dashboard/user",
  _signedURL: "admin/v1/common/getSignedURL",

  /* LOGIN FLOW APIs*/
  _login: "api/auth/login",
  _requestOtp: "api/auth/request-otp",
  _verifyOtp: "api/auth/verify-otp",
  _logout: "api/auth/logout",
  _currentProfile: "",

  // Dashboard APIs
  _dashboard: "api/dashboard",

  // Licences APIs
  _licenceList: "api/licence/list",

  // Ammunition APIs
  _ammunitionList: "api/ammunition/list",

  // Forms APIs
  _getFormByName: "api/forms/viewFormByName",
  _submitForm: "api/forms/submit",
  _getFormDetailsByName: "api/forms/viewFormDetailsByName",

  // Drafts
  _licenceDraft: "api/licence/draft",
  _armsDraft: "api/arms/draft",
  _ammunitionDraft: "api/ammunition/draft",

  // Arms
  _armsList: "api/arms/list",
};
